import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=583de845&scoped=true&"
import script from "./UserRow.vue?vue&type=script&lang=js&"
export * from "./UserRow.vue?vue&type=script&lang=js&"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=583de845&lang=scss&scoped=true&"
import style1 from "./UserRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583de845",
  null
  
)

export default component.exports